import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Folder } from 'src/app/models/folder';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.css']
})
export class ContextMenuComponent {

  @Input() x=0;
  @Input() y=0;
  assertFoolder;
  params= '';
  constructor(private httpService: HttpService, private router: Router, private activatedRoute: ActivatedRoute) { }

  addFolder(){
    this.assertFoolder = this.httpService.folder;
    let newFolder:Folder = new Folder("`!234");
    // newFolder.name = "x";
    if(this.assertFoolder.subFolders && this.assertFoolder.subFolders.length > 0){
      this.assertFoolder.subFolders = [ newFolder, ...this.assertFoolder.subFolders];
    }else{
      this.assertFoolder.subFolders = [newFolder];
    }
    
    console.log(this.assertFoolder);
  }

  renameFolder(){
    this.assertFoolder = this.httpService.folder;
    this.assertFoolder.rename = true;
  }
  upload(){
 this.httpService.currentSearchPath.subscribe(path => {
   this.params = path;
 });
 if (!this.params) {
  this.activatedRoute.params.subscribe(param=> {
    this.params = param.folder;
  });
}
 
    // debugger;
    this.router.navigateByUrl(`/upload-assets/${this.params}`);
  }

}
